export default __webpack_public_path__ + "static/media/Senna_productions.555e4dbd.jpg";